// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  display: flex;
  justify-content: space-between;
  margin: 20px;
  gap: 20px;
}

.box {
  background-color: #fff; /* Dark theme */
  color: #fff; /* White text color */
  /* border-radius: 10px; */
  width: calc(
    33% - 20px
  ); /* Adjust width based on the gap and number of boxes */
  box-sizing: border-box;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.graph-box .graph-placeholder,
.chart-box .chart-placeholder {
  height: 200px; /* Set a fixed height for placeholders */
  background-color: #fff; /* Slightly lighter than box background */
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.kw-box .kw-value {
  font-size: 3rem;
  font-weight: bold;
  margin-top: 10px;
}

.savings-widget-body {
  height: 100%;
  margin-top: -38px;
  padding-top: 38px;
  width: auto;
}

.savings-widget-title {
  width: 100%;
  color: #7b7c7e;
  z-index: 2;
  font-size: 16px;
  overflow: hidden;
  text-align: center;
  padding: 8px 15px 6px 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: uppercase;
  background-color: #fff;
  border-bottom: 2px solid #eceded;
  height: 38px;
}

/* Media query for mobile devices */
@media (max-width: 768px) {
  .dashboard {
    flex-direction: column; /* Stack the boxes vertically */
    margin: 20px 0; /* Adjust the margin for mobile */
    gap: 20px; /* Maintain the gap between boxes */
  }

  .box {
    width: auto; /* Boxes take the full width of the container on mobile */
    margin-bottom: 20px; /* Maintain vertical space between boxes */
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,sBAAsB,EAAE,eAAe;EACvC,WAAW,EAAE,qBAAqB;EAClC,yBAAyB;EACzB;;GAEC,EAAE,sDAAsD;EACzD,sBAAsB;EACtB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa,EAAE,wCAAwC;EACvD,sBAAsB,EAAE,yCAAyC;EACjE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE;IACE,sBAAsB,EAAE,+BAA+B;IACvD,cAAc,EAAE,iCAAiC;IACjD,SAAS,EAAE,mCAAmC;EAChD;;EAEA;IACE,WAAW,EAAE,yDAAyD;IACtE,mBAAmB,EAAE,0CAA0C;EACjE;AACF","sourcesContent":[".dashboard {\n  display: flex;\n  justify-content: space-between;\n  margin: 20px;\n  gap: 20px;\n}\n\n.box {\n  background-color: #fff; /* Dark theme */\n  color: #fff; /* White text color */\n  /* border-radius: 10px; */\n  width: calc(\n    33% - 20px\n  ); /* Adjust width based on the gap and number of boxes */\n  box-sizing: border-box;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.graph-box .graph-placeholder,\n.chart-box .chart-placeholder {\n  height: 200px; /* Set a fixed height for placeholders */\n  background-color: #fff; /* Slightly lighter than box background */\n  margin-top: 10px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.kw-box .kw-value {\n  font-size: 3rem;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n.savings-widget-body {\n  height: 100%;\n  margin-top: -38px;\n  padding-top: 38px;\n  width: auto;\n}\n\n.savings-widget-title {\n  width: 100%;\n  color: #7b7c7e;\n  z-index: 2;\n  font-size: 16px;\n  overflow: hidden;\n  text-align: center;\n  padding: 8px 15px 6px 15px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-transform: uppercase;\n  background-color: #fff;\n  border-bottom: 2px solid #eceded;\n  height: 38px;\n}\n\n/* Media query for mobile devices */\n@media (max-width: 768px) {\n  .dashboard {\n    flex-direction: column; /* Stack the boxes vertically */\n    margin: 20px 0; /* Adjust the margin for mobile */\n    gap: 20px; /* Maintain the gap between boxes */\n  }\n\n  .box {\n    width: auto; /* Boxes take the full width of the container on mobile */\n    margin-bottom: 20px; /* Maintain vertical space between boxes */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
